/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} LightInputs */



/**
* | output |
* | --- |
* | "Light" |
*
* @param {LightInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const light = /** @type {((inputs?: LightInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<LightInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Clair")
	if (locale === "de") return /** @type {LocalizedString} */ ("Licht")
	if (locale === "it") return /** @type {LocalizedString} */ ("Leggero")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Свет")
	if (locale === "es") return /** @type {LocalizedString} */ ("Luz")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("光")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ライト")
	if (locale === "hi") return /** @type {LocalizedString} */ ("रोशनी")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Luz")
	return /** @type {LocalizedString} */ ("Light")
});